import {
  ApplicationView,
  StartControllerScope,
  useController,
} from '@aha-app/mvc';
import { InplaceField } from '@aha-app/react-in-place';
import React, { useCallback } from 'react';
import TriggerTemplate from '../UserSelector/TriggerTemplate';
import { UserSelectorController } from './UserSelectorController';

/**
 * This component displays a list of user avatars and has a dropdown for
 * selecting more users. This is used for the watchers attribute and the meeting
 * attendees attribute
 */
const UserSelector: React.FC = () => {
  const controller = useController(UserSelectorController);
  const { className, editable, value, selectroProps, ...props } =
    controller.props;

  const selectCallback = useCallback(
    ({ payload }) => {
      controller.actionToggleUser(
        payload.item.value || payload.item.data?.value,
        payload.item.selected === 1
      );
    },
    [controller]
  );

  const clearCallback = useCallback(() => {
    controller.actionClearUsers();
  }, [controller]);

  if (!editable) {
    return (
      <TriggerTemplate
        noneSelected={selectroProps.text.noneSelected}
        editable={editable}
      />
    );
  }

  return (
    <InplaceField
      {...props}
      {...selectroProps}
      type='selectro'
      selectroType='multiple'
      class={className}
      tabIndex='1'
      value={value}
      data-testid='inplace-field'
      callbacks={{
        select: selectCallback,
        clearAll: clearCallback,
      }}
      templates={internalProps => ({
        trigger: ({ items, state }) => {
          return (
            <TriggerTemplate
              noneSelected={state.text.noneSelected}
              editable={editable}
              class={internalProps.class}
              showInput={internalProps.showInput}
              focusing={internalProps.focusing}
            />
          );
        },
        ...selectroProps.templates,
      })}
    />
  );
};

export default StartControllerScope(
  UserSelectorController,
  ApplicationView(UserSelector)
);
